/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object, string, bool, func,
} from 'prop-types';
import { withRouter } from 'react-router';

// Material UI
import Button from '@material-ui/core/Button';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

const BackButton = ({ url, desktopButton, desktopHDButton, agentButton, clearCallBackState, desktopBackLink, ...props }) => {
   const goToPreviousPage = (url = '') => {
        const { history, location: { pathname } } = props;
        if (url) {
            history.push(url);
        } else {
            const paths = pathname.replace(/^\/|\/$/g, '').split('/');
            paths.pop();
            if (paths.length > 0) {
                const prevURL = ''.concat('/', paths.join('/'));
                history.push(prevURL);
            }
        }
   };
   if (desktopButton) {
      return (
            <Button
               className="back-link"
               onClick={() => goToPreviousPage(url)}
            >
               &#60; Back to My Orders
            </Button>
      );
   }
   if (desktopHDButton) {
      return (
            <Button
               className="secondary"
               onClick={() => goToPreviousPage(url)}
            >
               <KeyboardArrowLeft /> Back to My Orders
            </Button>
      );
   }
   if (desktopBackLink) { // To have back to order button as a link
      return (
            <Button
               className="link underline alignCenterLink"
               onClick={() => goToPreviousPage(url)}
            >
               <KeyboardArrowLeft /> Back to Orders
            </Button>
      );
   }
   if (agentButton) {
      return (
            <>
               <ArrowBackIosIcon />
               <Button
                  onClick={() => {
                        goToPreviousPage(url);
                        clearCallBackState();
                  }}
                  className="agentBackBtn"
               >

                  Back to agent login
               </Button>
            </>
      );
   }

   return (
      <Button
         className="ROSS-back-button"
         onClick={() => goToPreviousPage(url)}>
         <img src="https://images.contentstack.io/v3/assets/blt95e0138311135214/bltc1774512f33e3b8c/6053dd7d2a6c5a1cccb7a587/back-arrow.svg" alt="back" />
      </Button>
   );
}

BackButton.defaultProps = {
    url: '',
    desktopButton: false,
    desktopHDButton: false,
    agentButton: false,
    desktopBackLink: false,
};

BackButton.propTypes = {
    history: object.isRequired,
    location: object.isRequired,
    clearCallBackState: func,
    url: string,
    desktopButton: bool,
    desktopHDButton: bool,
    agentButton: bool,
    desktopBackLink: bool,
};

export default withRouter(BackButton);
